/* Call this factory with countryCode as param to retrieve a list of bankInfo configurations for market */

export var BankInfoConfigsFactory = (function() {
    /* Public Functions */

    var getBankInfoConfigs = function(countryCode) {
        switch (countryCode) {
        case 'US': {
            return USBankInfoConfigs;
        }
        case 'CA': {
            return CABankInfoConfigs;
        }
        // EMEA
        case 'GB': {
            CommonIbanBankInfoConfigs.banking.iban.uiMask = ibanConfigs().getMask(countryCode);
            return CommonIbanBankInfoConfigs;
        }
        case 'FR': {
            CommonIbanBankInfoConfigs.banking.iban.uiMask = ibanConfigs().getMask(countryCode);
            return CommonIbanBankInfoConfigs;
        }
        case 'PF': {
            CommonIbanBankInfoConfigs.banking.iban.uiMask = ibanConfigs().getMask(countryCode);
            return CommonIbanBankInfoConfigs;
        }
        case 'ES': {
            ESIbanBankInfoConfigs.banking.iban.uiMask = ibanConfigs().getMask(countryCode);
            return ESIbanBankInfoConfigs;
        }
        // Pacifics
        case 'NZ': {
            return NZBankInfoConfigs;
        }
        case 'AU': {
            return AUBankInfoConfigs;
        }
        // Mainland China
        case 'HK': {
            return DefaultBankInfoConfigs;
        }
        // SEA
        case 'MY': {
            return DefaultBankInfoConfigs;
        }
        case 'SG': {
            return DefaultBankInfoConfigs;
        }
        default: {
            return DefaultBankInfoConfigs;
        }
        }
    };

    var getIbanCountries = function() {
        return ibanConfigs().getIbanCountries();
    };

    /* Private Configurations */

    var USBankInfoConfigs = {
        banking: {
            accountHolder: {
                show: true,
                dropdown: false,
            },
            accountType: {
                show: true,
                dropdown: false,
            },
            bankName: {
                show: false,
                dropdown: false,
            },
            branchNumber: {
                show: false,
                dropdown: false,
            },
            iban: {
                show: false,
                dropdown: false,
            },
            accountNumber: {
                show: true,
                dropdown: false,
                maxLength: 17,
                minLength: 10
            },
            routingNumber: {
                show: true,
                dropdown: false,
                maxLength: 9
            },
            directDeposit: {
                show: true,
            },
            bankCheckExample: {
                show: true
            },
            prePopulate: {
                accountName: false
            }
        }
    };
    var CABankInfoConfigs = {
        banking: {
            accountHolder: {
                show: true,
                dropdown: false,
            },
            accountType: {
                show: false,
                dropdown: false,
            },
            bankName: {
                show: true,
                dropdown: true,
            },
            branchNumber: {
                show: false,
                dropdown: false,
            },
            iban: {
                show: false,
                dropdown: false,
            },
            accountNumber: {
                show: true,
                dropdown: false,
                maxLength: 12,
                minLength: null
            },
            routingNumber: {
                show: true,
                dropdown: false,
                maxLength: 5
            },
            directDeposit: {
                show: true,
            },
            bankCheckExample: {
                show: true
            },
            prePopulate: {
                accountName: false
            }
        }
    };
    var CommonIbanBankInfoConfigs = {
        banking: {
            accountHolder: {
                show: true,
                dropdown: false,
            },
            accountType: {
                show: false,
                dropdown: false,
            },
            bankName: {
                show: false,
                dropdown: false,
            },
            branchNumber: {
                show: false,
                dropdown: false,
            },
            iban: {
                show: true,
                dropdown: false,
            },
            accountNumber: {
                show: false,
                dropdown: false,
            },
            routingNumber: {
                show: false,
                dropdown: false,
            },
            directDeposit: {
                show: false,
            },
            bankCheckExample: {
                show: false
            },
            prePopulate: {
                accountName: false
            }
        }
    };
    var ESIbanBankInfoConfigs = {
        banking: {
            accountHolder: {
                show: true,
                dropdown: false,
            },
            accountType: {
                show: false,
                dropdown: false,
            },
            bankName: {
                show: false,
                dropdown: false,
            },
            branchNumber: {
                show: false,
                dropdown: false,
            },
            iban: {
                show: true,
                dropdown: false,
            },
            accountNumber: {
                show: false,
                dropdown: false,
            },
            routingNumber: {
                show: false,
                dropdown: false,
            },
            directDeposit: {
                show: true,
            },
            bankCheckExample: {
                show: false
            },
            prePopulate: {
                accountName: true
            }
        }
    };
    var NZBankInfoConfigs = {
        banking: {
            accountHolder: {
                show: true,
                dropdown: false,
            },
            accountType: {
                show: false,
                dropdown: false,
            },
            bankName: {
                show: true,
                dropdown: true,
            },
            branchNumber: {
                show: true,
                dropdown: false,
                uiMask: '',
                maxLength: 4,
                minLength: 4
            },
            iban: {
                show: false,
                dropdown: false,
            },
            accountNumber: {
                show: true,
                dropdown: false,
                maxLength: 9,
                minLength: 9
            },
            routingNumber: {
                show: false,
                dropdown: false,
            },
            directDeposit: {
                show: false,
            },
            bankCheckExample: {
                show: false
            },
            prePopulate: {
                accountName: false
            }
        }
    };
    var AUBankInfoConfigs = {
        banking: {
            accountHolder: {
                show: true,
                dropdown: false,
            },
            accountType: {
                show: false,
                dropdown: false,
            },
            bankName: {
                show: false,
                dropdown: false,
            },
            branchNumber: {
                show: true,
                dropdown: false,
                uiMask: '999-999',
                maxLength: 6,
                minLength: 6
            },
            iban: {
                show: false,
                dropdown: false,
            },
            accountNumber: {
                show: true,
                dropdown: false,
                maxLength: 12,
                minLength: 5
            },
            routingNumber: {
                show: false,
                dropdown: false,
            },
            directDeposit: {
                show: false,
            },
            bankCheckExample: {
                show: false
            },
            prePopulate: {
                accountName: false
            }
        }
    };

    var DefaultBankInfoConfigs = {
        banking: {
            accountHolder: {
                show: true,
                dropdown: false,
            },
            accountType: {
                show: false,
                dropdown: false,
            },
            bankName: {
                show: false,
                dropdown: false,
            },
            branchNumber: {
                show: false,
                dropdown: false,
            },
            iban: {
                show: false,
                dropdown: false,
            },
            accountNumber: {
                show: true,
                dropdown: false,
                maxLength: 32,
                minLength: null
            },
            routingNumber: {
                show: false,
                dropdown: false,
            },
            directDeposit: {
                show: false,
            },
            bankCheckExample: {
                show: true
            },
            prePopulate: {
                accountName: false
            }
        }
    };

    var ibanConfigs = function(market) {
        var mask = {
            'GB': '** **** **** **** **** **',
            'ES': '** **** **** **** **** **** ',
            'PF': '** ***** ***** *********** **',
            'FR': '** **** **** **** **** **** ***'
        };
        var getMask = function(market) {
            return mask[market];
        };

        var getIbanCountries = function() {
            return Object.keys(mask);
        };

        return {
            getMask: getMask,
            getIbanCountries: getIbanCountries
        };
    };

    return {
        getBankInfoConfigs: getBankInfoConfigs,
        getIbanCountries: getIbanCountries
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/banking/bankInfo-configs.js
// module id = 45
// module chunks = 0